import { v4 as uuid } from 'uuid';

export const surveyOptions = [
  {
    id: uuid(),
    label: 'Радио',
    value: 'Radio',
    key: 'radio',
  },
  {
    id: uuid(),
    label: 'Промоутеры',
    value: 'Promoteri care repartizează flyere',
    key: 'promoters',
  },
  {
    id: uuid(),
    label: 'Консультанты в PORT MALL',
    value: 'Vânzărorii consultanți din magazinele din PORT MALL',
    key: 'consultants',
  },
  {
    id: uuid(),
    label: 'Instagram',
    value: 'Instagram',
    key: 'instagram',
  },
  {
    id: uuid(),
    label: 'Facebook',
    value: 'Facebook',
    key: 'facebook',
  },
  {
    id: uuid(),
    label: 'TikTok',
    value: 'TikTok',
    key: 'tiktok',
  },
  {
    id: uuid(),
    label: 'Telegram',
    value: 'Telegram',
    key: 'telegram',
  },
  {
    id: uuid(),
    label: 'Мнение инфлюенсеров',
    value: 'Influenceri de opinie',
    key: 'influencers',
  },
  {
    id: uuid(),
    label: 'Уличные баннеры',
    value: 'bannere stradale',
    key: 'street-banners',
  },
  {
    id: uuid(),
    label: 'LED-экраны',
    value: 'LED-uri',
    key: 'led-screens',
  },
  {
    id: uuid(),
    label: 'Реклама в PORT MALL',
    value: 'PORT MALL',
    key: 'port-mall',
  },
];
